import types from './types';

const receiveOmniRegions = (regions) => ({
  type: types.RECEIVE_ALL_OMNI_REGIONS,
  data: regions
});

export default { receiveOmniRegions };
